import { IPortfolioNavigation } from 'const';

import useSectionLoader from './useSectionLoader';

const useSortedSectionWidgets = (
  sectionWidgets: ReturnType<typeof useSectionLoader>,
  navigation: IPortfolioNavigation[],
) => {
  const sortedSectionWidgets = [...sectionWidgets].sort((left, right) => {
    if (left.hasData && !right.hasData) {
      return -1;
    }
    if (!left.hasData && right.hasData) {
      return 1;
    }
    return 0;
  });

  const visibleNavigation = navigation.filter((nav) => {
    const navigationWidget = sectionWidgets.find((widget) => widget.sectionTypeCode === nav.sectionTypeCode);

    // оставляем навигацию включенных или статичных разделов
    return navigationWidget?.isVisible || nav.isStatic;
  });

  const sortedNavigation = visibleNavigation.sort((left, right) => {
    const leftIndex = sortedSectionWidgets.findIndex((data) => data.sectionTypeCode === left.sectionTypeCode);
    const rightIndex = sortedSectionWidgets.findIndex((data) => data.sectionTypeCode === right.sectionTypeCode);

    if (leftIndex === -1 || rightIndex === -1) {
      return 0;
    }

    return leftIndex - rightIndex;
  });

  return { sortedSectionWidgets, sortedNavigation };
};

export default useSortedSectionWidgets;
